import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=bea24006&"
import script from "./Author.vue?vue&type=script&lang=js&"
export * from "./Author.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports